import { createStateContext } from 'react-use';

import { ProductDetails } from 'helpers/fakeData';

export const [useOverridesContext, OverridesStateContextProvider] = createStateContext<{
  product: ProductDetails | null;
}>({
  product: null,
});
